import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getRole } from './Apicall';
import AccessDenied from '../pages/AccessDenied';

const isTokenExpired = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const decodedToken = JSON.parse(jsonPayload);
    const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
    return Date.now() >= expirationTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true; // If we can't decode the token, consider it expired
  }
};

const ProtectedRoute = ({ allowedRoles }) => {
  const location = useLocation();
  const [shouldLogout, setShouldLogout] = React.useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && isTokenExpired(token)) {
      localStorage.clear();
      setShouldLogout(true);
    }
  }, [location]);

  const token = localStorage.getItem('token');

  if (shouldLogout || (token && isTokenExpired(token))) {
    return <Navigate to="/login" replace />;
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
if (isTokenExpired(token)) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  const userRole = getRole();
   if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <AccessDenied />;
  }

  return <Outlet />;
};

export default ProtectedRoute; 